import request from '@/utils/request'

// 查询小微企业-融资服务产品管理列表
export function listRzfwcpgl(query) {
  return request({
    url: '/web/xwqy/rzfwcpgl/list',
    method: 'get',
    params: query
  })
}

// 查询小微企业-融资服务产品管理详细
export function getRzfwcpgl(recid) {
  return request({
    url: '/web/xwqy/rzfwcpgl/' + recid,
    method: 'get'
  })
}
